<template>
  <div>
    <a-table
      :columns="columns"
      :loading="false"
      :pagination="false"
      :style="{margin:'auto',background:'#fff',marginBottom:'20px'}"
      :dataSource="listsubscribers.data"
      :bordered="false"
      :rowKey="record => record.id"
    >
      <router-link
        :to="{name:'sites.overview',params:{siteId:rowData.id}}"
        slot="name"
        slot-scope="name,rowData"
      >{{name}}</router-link>
    </a-table>
    <template v-if="listsubscribers.meta">
      <a-pagination
        @change="pagination"
        v-model="listsubscribers.meta.current_page"
        :pageSize="listsubscribers.meta.per_page"
        :defaultCurrent="1"
        :total="listsubscribers.meta.total"
        :style="{justifyContent:'flex-end',display:'flex'}"
      />
    </template>
  </div>
</template>
<script>
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "2",
    width: "25%"
    //scopedSlots: { customRender: "name" }
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: "25%"
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    width: "25%"
  },

  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    width: "25%"
  }
];

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      columns,
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      listsubscribers: "sites/listsubscribers"
    })
  },
  methods: {
    pagination: function(a, b) {
      this.$store.commit("sites/PAGINATE_LIST_SUBSCRIBERS", {
        siteId: this.$route.params.siteId,
        listId: this.$route.params.listId,
        page: a
      });
    }
  },
  beforeCreate() {
    this.$store.commit("sites/GET_LIST_SUBSCRIBERS", this.$route.params);
  }
};
</script>

